<template>
    <div>
        <rkm-modal
            :buttons="['cancel']"
            extraLarge
            ref="RkmModal"
            title="Histórico dos exames"
        >

            <template>
                <rkm-area
                    v-for="(itemExame, index) in items"
                    :key="index"
                    :title="`${itemExame.exameNome} - ${itemExame.data}`"
                    no-margin-top
                    class="pb-0 mb-0"
                >

                    <rkm-table
                        :items="itemExame.composicao"
                        :fields="fields"
                        hide-filters
                    >

                        <template v-slot:custom-foot v-if="itemExame.observacao">
                            <tr>
                                <td class="table-td col-6">
                                    Observação
                                </td>
                                <td class="table-td col-6">
                                    {{ itemExame.observacao  }}
                                </td>
                            </tr>
                        </template>

                    </rkm-table>
                </rkm-area>
            </template>

            <template v-if="items.length == 0">
                <rkm-row
                    class="text-center"
                >
                    <rkm-col>
                        Nenhum histórico disponível.
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-modal>
    </div>
</template>

<script>

// Mixins.
import { error } from '@/mixins'

export default {
    computed: {
        fields() {
            const fields = [
                {
                    key: "descricao",
                    label: "Descrição",
                    class: 'col-6',
                    sortable: true
                },
                {
                    key: "resultado",
                    label: "Resultado",
                    class: 'col-6',
                    sortable: true
                },
            ]

            return fields
        },
    },
    data: () => ({
        dia: null,
        semanaId: null,
    }),
    methods: {
        open() {

            this.$refs.RkmModal.show()
        },
    },
    mixins: [ error ],
    props: {
        items: { type: Array, required: true }
    },
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
</style>
